import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { VexConfigService } from 'src/@vex/config/vex-config.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vex-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatIconModule]
})
export class FooterComponent implements OnInit, OnDestroy {
  constructor(private vexConfigService: VexConfigService,private translateService: TranslateService) {}
  year: number = new Date().getFullYear();
companyName :any;
Rights:any;
logoName:any;
  ngOnInit() {

//var lang = localStorage.getItem('lang');
this.vexConfigService.config$.subscribe((config)=>{
  this.logoName=config.sidenav.title;
  this.companyName=config.sidenav.title;
});

this.Rights=this.translateService.instant('ALL_RIGHT_RESERVED.TEXT');
    // if(lang == "ar"){
    //   this.logoName ="إجادة";
    //   this.companyName ="إجادة للنظم المحدودة";
    //   this.Rights = "جميع الحقوق محفوظة";
    // }
    // else{
    //   this.logoName = "Ejada";
    //   this.companyName ="Ejada Systems Limited";
    //   this.Rights = "All Rights Reserved.";
    //     }

  }



  ngOnDestroy(): void {}
}
